import React from "react";
import { Editor } from "react-draft-wysiwyg";
import { FaChevronDown } from "react-icons/fa";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleArrowLeft, faFloppyDisk } from "@fortawesome/free-solid-svg-icons";
import { useCreateStudy } from "../../../hooks/useCreateStudy";
import "./NewStudy.css";
import "../study.css";
import "../../../App"

const NewStudy = ({ onBack }) => {
  const {
    name,
    setName,
    contact,
    setContact,
    editorState,
    setEditorState,
    editorState2,
    setEditorState2,
    loading,
    handleSubmit,
    errors,
  } = useCreateStudy(onBack);

  return (
    <div className="overflow-y-auto px-0" style={{ height: "100%" }}>
      <div className="container-fluid">
        <div className="row g-3">
          {/* Study name */}
          <div className="col-6 d-flex align-items-center gap-2 ">
            
            <div
              className="d-flex align-items-center back-arrow"
              onClick={onBack}
              style={{ cursor: "pointer" }}
            >
              <FontAwesomeIcon icon={faCircleArrowLeft} />
            </div>

            <div className="study-field py-1 px-4 flex-grow-1 w-100">
              <span className="study-field-label">Nom de l'étude</span>
              <input
                type="text"
                className="w-100"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Saisir le nom de l'étude..."
              />
              {errors.name && (
                <small className="study-error text-danger">{errors.name}</small>
              )}
            </div>
          </div>

          {/* Contact */}
          <div className="col-6 d-flex flex-column align-items-start">
            <div className="study-field py-1 px-4 w-100">
              <span className="study-field-label">Contact de l'étude</span>
              <input
                type="email"
                className="w-100 "
                value={contact}
                onChange={(e) => setContact(e.target.value)}
                placeholder="Saisir le contact de l'étude..."
              />
              {errors.contact && (
                <small className="study-error text-danger">{errors.contact}</small>
              )}
            </div>
          </div>
        </div>

        {/* Editors */}
        <div className="row g-3 px-2 py-0 mt-2">
          {/* Résumé */}
          <a
            className="collapsable-btn p-3 d-flex justify-content-between align-items-center"
            data-bs-toggle="collapse"
            href="#collapseResume"
            role="button"
            aria-expanded="false"
            aria-controls="collapseResume"
          >
            <span>Résumé de l'étude</span>
            <FaChevronDown />
          </a>
          <div className="collapse text-div py-2 px-3" id="collapseResume">
            <Editor
              editorState={editorState}
              onEditorStateChange={setEditorState}
              wrapperClassName="demo-wrapper"
              editorClassName="demo-editor border p-2 rounded bg-white"
              toolbar={{
                options: ["inline", "list", "textAlign", "history"],
                inline: { options: ["bold", "italic", "underline"] },
              }}
              placeholder="Écrivez votre texte ici..."
            />
          </div>

          {/* Protocole */}
          <a
            className="collapsable-btn p-3 d-flex justify-content-between align-items-center"
            data-bs-toggle="collapse"
            href="#collapseProtocole"
            role="button"
            aria-expanded="false"
            aria-controls="collapseProtocole"
          >
            <span>Protocole de l'étude</span>
            <FaChevronDown />
          </a>
          <div className="collapse text-div py-2 px-3" id="collapseProtocole">
            <Editor
              editorState={editorState2}
              onEditorStateChange={setEditorState2}
              wrapperClassName="demo-wrapper"
              editorClassName="demo-editor border p-2 rounded bg-white"
              toolbar={{
                options: ["inline", "list", "textAlign", "history"],
                inline: { options: ["bold", "italic", "underline"] },
              }}
              placeholder="Écrivez votre texte ici..."
            />
          </div>
        </div>

        {/* Submit */}
        <div className="d-flex justify-content-end mt-4">
          <button
            className="study-btn w-25"
            onClick={handleSubmit}
            disabled={loading}
          >
            <FontAwesomeIcon icon={faFloppyDisk} className="me-2" />
            {loading ? "Ajout..." : "Ajouter"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default NewStudy;
